/* eslint-disable import/prefer-default-export */
import {
  fetchMiniTvDataV2,
  postReceiveMinitvData,
} from 'components/MiniTvV3/util';
import reducerRegistry from '../../reduxUtils/reducerRegistry';

const reducerName = 'miniTv';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECIEVE_MINITV_DATA = createActionName('RECIEVE_MINITV_DATA');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
export const SHOW_MINITV_PLAYER = createActionName('SHOW_MINITV_PLAYER');
export const CLOSE_MINITV_PLAYER = createActionName('CLOSE_MINITV_PLAYER');

export function showMiniTvPlayer(isShown) {
  return {
    type: SHOW_MINITV_PLAYER,
    payload: {
      showMiniTv: isShown,
    },
  };
}
export function hideAnimation() {
  return {
    type: CLOSE_MINITV_PLAYER,
    payload: {
      isActiveFrom: 'noMiniTV',
    },
  };
}
function recieveMiniTvData(data) {
  return {
    type: RECIEVE_MINITV_DATA,
    payload: {
      ...data,
    },
  };
}
function handleDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    payload: {
      isActiveFrom: 'noMiniTV',
      error,
    },
  };
}

export function getMinitvConfig(mdata, props) {
  const { isWapView, layoutConfig = {}, jarvisLayoutConfig = {} } = props;

  if (mdata?.jmweb_setting && isWapView) {
    mdata = {
      ...mdata,
      ...mdata.jmweb_setting,
    };
  }
  const layoutConf = {
    ...layoutConfig,
    ...jarvisLayoutConfig,
  };
  if (!layoutConf.skipPageLvl) {
    return {
      ...mdata,
      ...layoutConf,
    };
  }
  return mdata;
}

export function loadMiniTv(setting) {
  const { unsticky, isWapView } = setting;
  return dispatch => {
    let data = null;
    let isActiveFrom = 'noMiniTV';
    const startloadingAssest = (mdata, from, videoEnable) => {
      if (mdata) {
        const isSickyClose = unsticky && mdata?.sticky;
        if (isSickyClose) {
          mdata.sticky = false;
        }
        mdata = getMinitvConfig(mdata, setting);
      }
      if (mdata || videoEnable) {
        dispatch(
          recieveMiniTvData({ data: mdata, isActiveFrom: from, videoEnable }),
        );
      }
    };
    const prop = { ...setting, isMobile: isWapView };
    fetchMiniTvDataV2(prop)
      .then(jdata => {
        data = postReceiveMinitvData(jdata?.data, prop);
        if (data) {
          isActiveFrom = 'jarvis';
          startloadingAssest(data, isActiveFrom, true);
        } else {
          isActiveFrom = 'noMiniTV';
          startloadingAssest(null, isActiveFrom, false);
        }
      })
      .catch(error => dispatch(handleDataError(error)));
  };
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case RECIEVE_MINITV_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case SHOW_MINITV_PLAYER:
      return {
        ...state,
        showMiniTvPlayer: action.payload.showMiniTv,
      };
    case CLOSE_MINITV_PLAYER:
      return {
        ...state,
        isActiveFrom: action.payload.isActiveFrom,
      };
    case HANDLE_DATA_ERROR:
      return {
        ...state,
        isActiveFrom: action.payload.isActiveFrom,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
